import Guid from "@/app/types/common/guid";

export function getUniqueId(guid: Guid = Guid.create()) {
  // HTML id attributes must not start with a number.
  return "U" + guid.toString().replace("-", "");
}
